import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { AddCircleOutline as AddCircleOutlineIcon } from '@material-ui/icons';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import { translation } from '../../i18n';
import { ExpansionPanel } from '@material-ui/core';
import { ExpansionPanelSummary } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { ExpansionPanelDetails } from '@material-ui/core';
import { QuestionClusterDto } from '../../pages/questionClusterTypes';
import { observer } from 'mobx-react';
import { IObservableValue, observable } from 'mobx';
import { IconButton } from '@material-ui/core';
import QuestionPreview from './QuestionPreview';
import MultilineText from '../MultilineText';

interface Props {
  cluster: QuestionClusterDto;
  expanded: IObservableValue<string>;
  handleAdd?: (module: QuestionClusterDto) => void;
}

type LocalStyles = 'root' | 'button' | 'heading' | 'summaryArea' | 'detailArea' | 'chip';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    textAlign: 'center',
  },
  button: {
    margin: theme.spacing.unit,
    right: theme.spacing.unit * 2,
    bottom: theme.spacing.unit * 2,
    position: 'fixed'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    paddingLeft: theme.spacing.unit
  },
  summaryArea: {
    alignItems: 'center', display: 'flex',
    flexDirection: 'row',
  },
  detailArea: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left'
  },
  chip: {
    margin: theme.spacing.unit,
  },
});


type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class QuestionClusterPreview extends React.Component<PropsWithStyle, {}> {

  private expandedQuestion: IObservableValue<string> = observable.box('');

  constructor(props: PropsWithStyle) {
    super(props);
  }

  public render() {
    const {cluster} = this.props;
    return (
      <ExpansionPanel key={cluster.id + 'cluster-panel'}
                      expanded={this.props.expanded.get() === (cluster.id + 'cluster-panel')}
                      onChange={() => {
                        if (this.props.expanded.get() === (cluster.id + 'cluster-panel')) {
                          this.props.expanded.set('')
                        } else {
                          this.props.expanded.set(cluster.id + 'cluster-panel')
                        }
                      }}>
        <ExpansionPanelSummary key={cluster.id + 'cluster-summary'} expandIcon={<ExpandMoreIcon/>}>
          <div className={this.props.classes.summaryArea}>
            {
              this.props.handleAdd &&
              <div>
                <IconButton onClick={(event) => {
                  event.stopPropagation();
                  this.props.expanded.set('');
                  this.props.handleAdd!!(this.props.cluster);
                }}>
                  <AddCircleOutlineIcon color={'primary'}/>
                </IconButton>
              </div>
            }

            <div>
              {
                cluster.title ?
                  <Typography className={this.props.classes.heading}>{cluster.title}</Typography> :
                  <Typography
                    className={this.props.classes.heading}>{translation.t('createCatalogueComponent.noClusterTitle')}</Typography>
              }
            </div>
          </div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails className={this.props.classes.detailArea} key={cluster.id + 'cluster-details'}>
          {
            cluster.description &&
            <>
              <div>
                <Typography style={{textAlign: 'left'}}>
                  <MultilineText text={cluster.description}/>
                </Typography>
              </div>
              <br/>
            </>
          }
          <div>
            <Typography style={{textAlign: 'left'}}>
              {translation.t('cluster.question')}:
            </Typography>
          </div>
          <div>
            {
              cluster.questions.map(question => {
                  return (<QuestionPreview key={question.id + 'question'} classes={this.props.classes}
                                           expanded={this.expandedQuestion}
                                           question={question}/>)
                }
              )
            }
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}

export default withStyles(localStyles)(QuestionClusterPreview);
